import { blastFiringAjax } from "../../ajax/BlastFiringAjax";
import { blastMonitorsAjax } from "../../ajax/BlastMonitorsAjax";
import { blastPatternAjax } from "../../ajax/BlastPatternAjax";
import { BlastFiringRecordDTO, PatternFragmentationDTO } from "../../DTOs/DrillBlast/FiringDTO";
import { BlastMonitorDTO, PatternMonitoringDTO } from "../../DTOs/DrillBlast/MonitoringDTO";
import { PatternDetailDTO } from "../../DTOs/DrillBlast/PatternLifecycleDTO";
import { drillBlastQuery, lookupQuery } from "./useDrillBlastLookups";

export const patternQuery = (patternId: number) => drillBlastQuery<PatternDetailDTO>(['drillBlast', 'pattern', patternId], 'the blast pattern',
  () => blastPatternAjax.getPattern(patternId));

export const firingRecordQuery = (patternId: number) => drillBlastQuery<BlastFiringRecordDTO>(['drillBlast', 'firing', patternId], 'the firing record',
  () => blastFiringAjax.getRecord(patternId));

export const fragmentationQuery = (patternId: number) => drillBlastQuery<PatternFragmentationDTO>(['drillBlast', 'fragmentation', patternId],
  'the fragmentation surveys', () => blastFiringAjax.getFragmentation(patternId));

export const monitoringQuery = (patternId: number) => drillBlastQuery<PatternMonitoringDTO>(['drillBlast', 'monitoring', patternId],
  'the monitoring readings', () => blastFiringAjax.getMonitoring(patternId));

export const blastMonitorsQuery = lookupQuery<BlastMonitorDTO>(['drillBlast', 'monitorOptions'], 'the monitors', () => blastMonitorsAjax.getMonitors());
